// extracted by mini-css-extract-plugin
module.exports = {"comp":"B_comp__C_cye"};